// @todo check if this is used
import React, { useState, useEffect } from 'react'
import CloseIcon from '@material-ui/icons/Close'
import ShareIcon from '@material-ui/icons/Share'
import { Snackbar, IconButton, Button } from '@material-ui/core'
import { useLiterals } from '~/components/Literals'
import FileCopyIcon from '@material-ui/icons/FileCopyOutlined'
import track from '../../track'

function SpeedDial({ product = {}, mobile }) {
  const url = `${window.location.origin}/product/${product.gtin}`
  const { getLiteral } = useLiterals()
  const [copy, setCopy] = useState()

  const handleCopy = (url) => () => {
    const aux = document.createElement('div')
    aux.setAttribute('contentEditable', true)
    aux.innerHTML = url
    document.body.appendChild(aux)
    window.getSelection().selectAllChildren(aux)
    document.execCommand('copy')
    document.body.removeChild(aux)
    setCopy(true)
    track('copiarProduto', { url, type: 'clipboard', category: 'produto', name: product?.name })
  }

  const handleClose = () => {
    setCopy(false)
  }

  const handleShareApi = (url) => () => {
    navigator.share({
      title: `${getLiteral('2031')} ${product.name}`,
      text: `${getLiteral('2031')} ${product.name}`,
      url
    })

    track('compartilharProduto', { url, type: 'shareApi', category: 'produto' })
  }

  useEffect(() => {
    if (copy) {
      setTimeout(() => setCopy(false), 1500)
    }
  }, [copy])

  return (
    <div>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={copy}
        message={getLiteral('1905')}
        action={
          <IconButton aria-label="close" color="inherit" onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        }
      />

      <Button
        variant="outlined"
        onClick={mobile ? handleShareApi(url) : handleCopy(url)}
        startIcon={mobile ? <ShareIcon color="primary" /> : <FileCopyIcon color="primary" />}
        size={mobile ? 'small' : 'medium'}
        style={{ borderColor: '#EEEBEB' }}
      >
        {mobile ? getLiteral('2345') : getLiteral('2032')}
      </Button>
    </div>
  )
}

export default SpeedDial
